var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "observer" },
    [
      _vm.modal
        ? _c("modal-assinatura", {
            attrs: {
              titulo: "Assinar Ofício de Certidão Negativa",
              texto:
                "Para realizar a assinatura do ofício de certidão negativa é necessário informar a senha do seu certificado digital. Ao finalizar, o documento será assinado."
            },
            on: {
              closeModal: function($event) {
                return _vm.closeModal()
              },
              callbackSucesso: _vm.callbackModalAssinatura
            }
          })
        : _vm._e(),
      _c("div", { staticClass: "container-cadastro" }, [
        _c(
          "div",
          { attrs: { id: "passos" } },
          [
            _c(
              "el-steps",
              {
                attrs: {
                  active: _vm.passoAtivo,
                  "finish-status": "success",
                  simple: "simple"
                }
              },
              [
                _c("el-step", { attrs: { title: "Informar dados" } }),
                _c("el-step", { attrs: { title: "Confirmar dados" } })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { attrs: { id: "corpo" } },
          [
            _vm.passoAtivo === 0
              ? _c("informar-dados", {
                  attrs: { processo: _vm.processo },
                  on: {
                    atualizarListaCartorios: _vm.atualizarListaCartorios,
                    atualizarAnexos: _vm.atualizarAnexos,
                    changeInteiroTeor: _vm.changeInteiroTeor,
                    exitInformarDados: _vm.exitInformarDados
                  }
                })
              : _vm._e(),
            _vm.passoAtivo === 1
              ? _c(
                  "confirmar-dados",
                  _vm._g(
                    {
                      attrs: { oficios: _vm.oficios },
                      on: { getBytesPdf: _vm.getBytesPdf }
                    },
                    _vm.$listeners
                  )
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _c("app-buttons-cadastro", {
        attrs: {
          isPrimeiroPasso: false,
          isUltimoPasso: _vm.ultimoPasso,
          showButtonSalvar: false,
          showButtonDownload: _vm.ultimoPasso,
          showButtonCancelar: false,
          showButtonProximo: !_vm.ultimoPasso
        },
        on: {
          proximo: _vm.proximo,
          salvar: _vm.salvar,
          voltar: _vm.voltar,
          finalizar: _vm.finalizar,
          download: _vm.download
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37ab9a36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37ab9a36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/cpat/components/oficio/EmissaoOficio.vue
// module id = null
// module chunks = 